import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [badges, setBadges] = useState({ notifications: 0, inbox: 0 });

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("ft_token")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ft_token");
      setUser(false);
    }
  }, []);

  const loadBadges = useCallback(async () => {
    try {
      const { data } = await api.get("/me/badges");
      setBadges(data);
    } catch {
      /* badges are non-critical */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!user) return undefined;
    loadBadges();
    const t = setInterval(loadBadges, 15000);
    return () => clearInterval(t);
  }, [user, loadBadges]);

  const signIn = (data) => {
    localStorage.setItem("ft_token", data.token);
    if (data.device_token) localStorage.setItem("ft_device", data.device_token);
    setUser(data.user);
  };
  const signOut = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ft_token");
    localStorage.removeItem("ft_zip");
    setBadges({ notifications: 0, inbox: 0 });
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, signIn, signOut, badges, loadBadges, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
